// extracted by mini-css-extract-plugin
export default {"email":"Contact_email__n41v8","fb":"Contact_fb__OtJ2F","ig":"Contact_ig__toZSl","fk":"Contact_fk__FMUEs","yt":"Contact_yt__KzpSF"};